import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PinLocationAIcon, RadiusIcon } from '@/assets';
import { LabeledContent } from '@/components/layouts';
import { DATE_TIME_WITH_ZONE_FORMAT } from '@/constants/dates';
import { makeSelectTimezone } from 'containers/App/selectors';
import { COLORS } from 'theme';
import { getFormattedTime } from 'utils/v2';

import { InfoWindowContentContainer } from '../../Map.styles';
import MarkerWithInfoWindow from '../MarkerWithInfoWindow';

const PickupMarker = ({ position, formattedAddress, pickupDateTime }) => {
  const timeZone = useSelector(makeSelectTimezone());

  const infoWindowContent = useMemo(
    () => (
      <InfoWindowContentContainer>
        <LabeledContent content={formattedAddress} label="From" />
        {pickupDateTime && (
          <LabeledContent
            content={getFormattedTime(pickupDateTime, {
              format: DATE_TIME_WITH_ZONE_FORMAT,
              zone: timeZone,
            })}
            label="Pickup Time"
          />
        )}
      </InfoWindowContentContainer>
    ),
    [formattedAddress, pickupDateTime],
  );

  return (
    <MarkerWithInfoWindow
      position={position}
      infoWindowContent={infoWindowContent}
    >
      <RadiusIcon
        size="48px"
        color={COLORS.kinetikBlue}
        sx={{
          position: 'absolute',
          transform: 'translateY(50%)',
          zIndex: -1,
        }}
      />
      <PinLocationAIcon size="48px" primaryColor={COLORS.black40} />
    </MarkerWithInfoWindow>
  );
};

PickupMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  formattedAddress: PropTypes.string,
  pickupDateTime: PropTypes.string,
};

export default PickupMarker;
